import React from 'react';

// The one card style of the room column (`neg-panel`, 1rem apart): info,
// requirement, bid spec and line selector share it with Adjust / history.
const RoomPanel = ({ title, description, icon, children }) => (
  <section className='neg-panel'>
    <header className='neg-panel__head'>
      <div>
        <h3 className='neg-panel__title'>
          {icon && <i className={icon} aria-hidden='true' />}
          {title}
        </h3>
        {description && <p className='neg-panel__desc'>{description}</p>}
      </div>
    </header>
    <div className='neg-panel__body'>{children}</div>
  </section>
);

export default RoomPanel;
